module.exports = __webpack_public_path__ + "img/1.63ad5804.png";